export default __webpack_public_path__ + "static/media/md.2a07174f.svg";